import { useCallback, useMemo } from 'react';
import { useOrganization } from '../contexts/OrganizationContext';
import { Currency, DEFAULT_CURRENCY, getOrganizationCurrency } from '../models/Organization';
import { formatCurrency, getCurrencySymbol, FormatCurrencyOptions } from '../utils/currency';

/**
 * Resolves the current organization's currency and returns helpers bound to it,
 * so components can format money without repeating the org lookup. Falls back to
 * the default currency while the org is still loading or unset.
 */
export function useCurrency() {
  const { organization } = useOrganization();
  const currency: Currency = organization ? getOrganizationCurrency(organization) : DEFAULT_CURRENCY;

  const format = useCallback(
    (amount: number | null | undefined, options?: FormatCurrencyOptions) =>
      formatCurrency(amount, currency, options),
    [currency]
  );

  const symbol = useMemo(() => getCurrencySymbol(currency), [currency]);

  return { currency, symbol, format };
}
